module.exports = __webpack_public_path__ + "static/media/logo7@2x.10006b26.png";